import type {FC} from 'react';

import dayjs from 'dayjs';
import {Observer} from 'mobx-react';

import type {MembershipExpandedCommon} from '../../../../api/membership';
import type {Clickable} from '../../../../uikit/Clickable';
import type {GetComponentProps} from '../../../../utils/utility-types';
import type {RequestsStore} from '../../stores/Requests';

import {datetimeObjToISOString} from '../../../../utils/datetime';
import {getCourseLabel} from '../../../../utils/entity/course';
import {getFileSrc} from '../../../../utils/entity/file';
import {LONG_DATE_FORMAT} from '../../../book-conference/utils/constants';
import {RequestsListItemJSX} from '../../components/RequestsListItem';

type Props = {
  membership: MembershipExpandedCommon;
  onMoreClick?: (
    action: Parameters<GetComponentProps<typeof Clickable>['onClick']>[0],
    membership: MembershipExpandedCommon,
  ) => void;
  store: RequestsStore;
};

export const RequestsListItem: FC<Props> = ({
  membership,
  onMoreClick,
  store,
}) => {
  const createdAt = dayjs(datetimeObjToISOString(membership.created)).format(
    LONG_DATE_FORMAT,
  );

  const courseLabel = getCourseLabel(membership.course);

  const avatarUrl = getFileSrc(membership.user.avatar, 250).url ?? '';

  return (
    <Observer>
      {() => (
        <RequestsListItemJSX
          avatarUrl={avatarUrl}
          courseLabel={courseLabel}
          createdAt={createdAt}
          onAcceptClick={
            store.isEditionSignedForMembership(membership)
              ? () => store.acceptOne(membership)
              : undefined
          }
          onDeclineClick={
            store.isEditionSignedForMembership(membership)
              ? () => store.declineOne(membership)
              : undefined
          }
          onMoreClick={
            onMoreClick ? action => onMoreClick(action, membership) : undefined
          }
          onSelectClick={() => store.toggleSelection(membership._id)}
          selected={store.isSelected(membership._id)}
          username={membership.user_name}
        />
      )}
    </Observer>
  );
};
